export default "__VITE_ASSET__D5Bp72b7__"